import { Box, Typography } from "@mui/material";

interface SurchargeProps {
  bannerText: string;
  headingText?: string;
  creditCardBanner?: boolean
}

const Surcharge = ({ bannerText, headingText, creditCardBanner = true }: SurchargeProps) => {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        backgroundColor: theme.palette.customcolor.surchargeBackground,
        border: `1px solid ${theme.palette.customcolor.surchargeBorder}`,
        borderRadius: 2,
        p: 2,
        gap: 1,
        marginY: 1,
      })}>
      {headingText && (
        <Typography
          sx={(theme) => ({ color: theme.palette.customcolor.footerTextColor })}
          fontSize={"14px"}
          fontWeight={"bold"}>
          {headingText}
        </Typography>
      )}

      <Typography
        sx={(theme) => ({ color: theme.palette.customcolor.footerTextColor })}
        fontSize={"14px"}
        fontWeight={creditCardBanner ? 700 : 400}>
        {bannerText}
      </Typography>
    </Box>
  );
};

export default Surcharge;
